var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDirectionsWalk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 50 50"
}, props), /*#__PURE__*/React.createElement("mask", {
  width: 50,
  height: 50,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h50v50H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6C6C6C",
  d: "m15.945 46.875 6.114-30.096-6.154 2.5v6.723h-2.083v-8.11l9.239-3.918a4.9 4.9 0 0 1 1.376-.384q.647-.073 1.256.068.608.14 1.1.509.49.368.867.977l1.442 2.292q1.755 2.868 4.153 4.535a10.66 10.66 0 0 0 5.287 1.907v2.083q-3.486-.32-6.21-2.111-2.726-1.79-4.716-4.856l-1.903 9.532 4.495 4.727v13.622h-2.083v-12.22l-5.817-5.376-4.231 17.596zm12.18-36.058q-1.478 0-2.502-1.023-1.024-1.024-1.024-2.502 0-1.479 1.024-2.502 1.024-1.024 2.502-1.024t2.502 1.024q1.023 1.023 1.023 2.502t-1.023 2.502-2.502 1.023"
}))));
export default SvgDirectionsWalk;